import EffectiveNav from 'components/Nav/EffectiveNav'
import Footer from 'components/Footer'
import { useRef } from 'react'
import DiscoverPreviousEvents from 'components/discover/DiscoverEvents/DiscoverPreviousEvents'
import HelpFAQ from 'components/discover/DiscoverEvents/HelpFAQ'
import DiscoverUpcomingEvents from 'components/discover/DiscoverEvents/DiscoverUpcomingEvents'
import ExploreHero from 'components/discover/DiscoverEvents/ExploreHero'

function DiscoverEventsPage() {
  const upcomingEventsRef = useRef<HTMLDivElement>(null!)

  return (
    <div>
      <EffectiveNav />

      <ExploreHero
        onBrowseClick={() =>
          upcomingEventsRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      />

      <div ref={upcomingEventsRef}>
        <DiscoverUpcomingEvents />
      </div>

      <DiscoverPreviousEvents />
      <HelpFAQ />
      <Footer />
    </div>
  )
}

export default DiscoverEventsPage
